import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpContext } from '@angular/common/http'
import { LoadingServiceNotifications } from '@shared/services/loading.interceptor'
import { firstValueFrom } from 'rxjs'

export interface ServiceNotification {
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class ServiceNotificationsService {
  private http = inject(HttpClient)
  items() {
    return firstValueFrom(
      this.http.get<ServiceNotification[]>('/api/v1/services_status', {
        context: new HttpContext().set(LoadingServiceNotifications, true),
      }),
    )
  }
}
